
import { mapState } from 'vuex';
import Snackbar from '@/components/common/Snackbar.vue';

export default {
  components: { Snackbar },

  computed: {
    ...mapState('notificationStore', ['toasts']),
    orderedToasts() {
      return [...this.toasts].reverse();
    },
  },

  methods: {
    snackbarPosition(index) {
      let i = index;
      let topOffset = 0;

      if (!this.$refs.items?.[i - 1]) return null;

      while (i > 0) {
        const elemHeight = this.$refs.items[i - 1]?.$el.children[0].clientHeight;
        topOffset += elemHeight + 12;
        i--;
      }

      return { top: `${topOffset}px` };
    },
  },
};
